import $ from "jquery";

$('.illumi-p-header__navi a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var adjust = 0;
    if (href == '#welcome') {
        adjust = -120;
    } else if (href == '#illumination') {
        if (window.matchMedia('(min-width:640px)').matches) {
            adjust = 400;
        } else {
            adjust = -60;
        }
    }
    var speed = 400;
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
});

window.addEventListener('DOMContentLoaded', function () {
    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {

            if (entry.isIntersecting) {
                // console.log(entry.target.id + ' is intersecting');

                const currentActiveIndex = document.querySelector(".illumi-p-header__navi .is-active");
                if (currentActiveIndex !== null) {
                    currentActiveIndex.classList.remove("is-active");
                }

                const newActiveLink = document.querySelector(`.illumi-p-header__navi a[href='#${entry.target.id}']`);
                if (newActiveLink && newActiveLink.parentElement) {
                    newActiveLink.parentElement.classList.add("is-active");

                    // .illumi-p-header__navi-currentを移動させる
                    const currentIndicator = document.querySelector('.illumi-p-header__navi-current');
                    const newPositionTop = newActiveLink.parentElement.getBoundingClientRect().top - newActiveLink.parentElement.parentElement.getBoundingClientRect().top;
                    currentIndicator.style.top = newPositionTop + "px";
                }
            }  else {
                if (entry.target.id === 'welcome') {
                    let getActiveIndex = document.querySelector(".illumi-p-header__navi .is-active");

                    if (getActiveIndex !== null) {
                        getActiveIndex.classList.remove("is-active");
                    }
                }
            }
        });
    }, { rootMargin: '-50% 0px' });

    let targets = document.querySelectorAll('.js-nav-scroll');

    targets.forEach(target => {
        if (target) {
            observer.observe(target);
        } else {
            console.log('target element not found');
        }
    });
});
